module.exports = __webpack_public_path__ + "static/media/left.b63197fa.svg";